import Inquiry  from './inquiry';
// import  PhoneIntl from './phone_intl';
const Form = {
    init() {
        this._initValidations();
    },
    _initValidations() {
        Inquiry.init();
        // PhoneIntl.init();
    },

}
export default Form;



// WEBPACK FOOTER //
// ./scripts/modules/forms/form.js